import type { LucideIcon } from "lucide-react";
import { ArrowUpCircle, Clapperboard, Film, ImageIcon, Video, Wand2 } from "lucide-react";

import type { ArtifactType, GenerationMode } from "./chat-models";

export interface QuickAction {
    readonly id: string;
    readonly icon: LucideIcon;
    readonly labelKey: string;
    readonly descKey: string;
    readonly type: ArtifactType;
    readonly mode: GenerationMode;
    readonly color: string;
}

export const QUICK_ACTIONS: readonly QuickAction[] = [
    {
        id: "t2i",
        icon: ImageIcon,
        labelKey: "actions.textToImage.label",
        descKey: "actions.textToImage.desc",
        type: "image",
        mode: "text_to_image",
        color: "from-blue-500/20 to-blue-600/5",
    },
    {
        id: "t2v",
        icon: Video,
        labelKey: "actions.textToVideo.label",
        descKey: "actions.textToVideo.desc",
        type: "video",
        mode: "text_to_video",
        color: "from-violet-500/20 to-violet-600/5",
    },
    {
        id: "i2v",
        icon: Film,
        labelKey: "actions.imageToVideo.label",
        descKey: "actions.imageToVideo.desc",
        type: "video",
        mode: "image_to_video",
        color: "from-purple-500/20 to-purple-600/5",
    },
    {
        id: "edit",
        icon: Wand2,
        labelKey: "actions.editImage.label",
        descKey: "actions.editImage.desc",
        type: "image",
        mode: "edit",
        color: "from-emerald-500/20 to-emerald-600/5",
    },
    {
        id: "ups",
        icon: ArrowUpCircle,
        labelKey: "actions.upscale.label",
        descKey: "actions.upscale.desc",
        type: "image",
        mode: "upscale_image",
        color: "from-amber-500/20 to-amber-600/5",
    },
    {
        id: "frm",
        icon: Clapperboard,
        labelKey: "actions.framesToVideo.label",
        descKey: "actions.framesToVideo.desc",
        type: "video",
        mode: "frames",
        color: "from-rose-500/20 to-rose-600/5",
    },
] as const;
